var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.updateValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }